module.exports = __webpack_public_path__ + "public/img/状态监控Bg.ed169f57.png";